/**
 * directives.utilities Module
 *
 * Description
 */
angular.module('directives.utilities')

.directive('utilities', [
    'configs',
    function (configs, bignumber) {

        var BigNumber = require('bignumber.js');

        return {
            restrict: 'E',
            replace: true,
            require: '?ngModel',
            scope: {
                form: '=',
                formcontroller: '='
            },
            template: require('./index.html'),
            controller: [
                '$scope',
                '$rootScope',
                function ($scope, $rootScope) {

                    var tariffConfig = configs.payments_config;
                    var tempTariff = tariffConfig.energyCalc.tariffs;

                    var countAmount = function () {
                        if (Utilities.selectedProducts.length > 0) {
                            Utilities.selectedProducts.forEach(function (product) {
                                $scope.form.service.service.amount_min = 0;
                                if (product.amount) {

                                    $scope.form.service.service.amount = new BigNumber($scope.form.service.service.amount).plus(product.amount < 0 ? 0 : product.amount|| 0).toFixed(2);
                                }
                                if (product.amountMin > 0) {

                                   $scope.form.service.service.amount_min = new BigNumber(product.amountMin).toFixed(2);
                                }
                            });

                            if (Utilities.selectedProducts[0].meters) {
                                Utilities.selectedProducts[0].meters.forEach(function (meter) {
                                    if (meter.Amount) {
                                        var amount = 0;

                                        if ($scope.form.service.payment && $scope.form.service.payment.amount) {
                                            amount = new BigNumber($scope.form.service.service.amount);
                                        }

                                        $scope.form.service.service.amount_min = 0;

                                        if ($scope.form.service.service.amount_min < meter.Amount) {
                                            if (Utilities.selectedProducts[0].debt) {};
                                            $scope.form.service.service.amount_min = new BigNumber(meter.Amount).toFixed(2);
                                        }

                                        $scope.form.service.service.amount = new BigNumber($scope.form.service.service.amount).plus(meter.Amount || 0).plus(amount).toFixed(2);
                                    }
                                });
                            };

                            for (product in Utilities.selectedProducts) {
                                $scope.form.service.service.amount = new BigNumber($scope.form.service.service.amount).plus(product.amountInput || 0).toFixed(2);
                            };
                        };
                    };

                    $scope.chooseProduct = function (argument) {
                        Utilities.selectedProducts = [];
                        $scope.chosenProduct = argument;
                        $scope.form.service.service.amount = 0;
                        $scope.formcontroller.$setValidity("paymentForm", true);

                        for (product in Utilities.products) {
                            if ($scope.chosenProduct === product.serviceName) {
                                Utilities.selectedProducts.push(product);

                                $scope.form.service.fields = product;
                            };
                        };

                        countAmount();
                    };

                    $scope.toFixed = function (number, precision) {
                        precision = precision || precision === 0 ? precision : 2;
                        if (number) {
                            return parseFloat(number).toFixed(precision);
                        }
                        return 0;
                    };

                    $scope.selectProduct = function (product) {

                        Utilities.selectedProducts = [];
                        Utilities.selectedProducts.push(product);
                    };

                    var Utilities = {
                        products: [],
                        selectedProducts: [],
                        parseDate: function (timestamp) {
                            return $.datepicker.formatDate('dd.mm.yy', new Date(timestamp));
                        },
                        calcDiscount: function (meter) {
                            var tariff = new BigNumber(Utilities.replaceComma(meter.tariff));

                            return tariff.times(meter.Privileges.Percent).div(100);
                        },
                        replaceComma: function (val) {
                            return val ? val.toString().replace(/\,/, '.') : 0;
                        },
                        calcMeter: function (meter, type) {
                            var oldVal = new BigNumber(Utilities.replaceComma(meter.previous)),
                                newVal = new BigNumber(Utilities.replaceComma(meter.current)),
                                tariff = new BigNumber(Utilities.replaceComma(meter.tariff)),
                                calcVal = newVal.minus(oldVal),
                                calcSum = 0,
                                discount = 0,
                                units = 0;

                            if (type === 'difference') {
                                if (meter.previous || meter.previous === 0) {
                                    newVal = oldVal.plus(meter.difference || 0);
                                    meter.current = newVal.toFixed(0);
                                    calcVal = newVal.minus(oldVal);
                                } else if (!meter.previous && !meter.current) {
                                    calcVal = new BigNumber(meter.difference);
                                } else {
                                    calcVal = newVal.minus(oldVal);
                                }
                            } else {
                                meter.difference = parseFloat(calcVal) >= 0 ? parseFloat(calcVal) : '';
                            }

                            if (meter.Privileges && (meter.Privileges.length > 0 || Object.keys(meter.Privileges).length > 0)) {
                                discount = Utilities.calcDiscount(meter);
                                units = new BigNumber(meter.Privileges.Units);

                                if (newVal.gt(oldVal) && calcVal.minus(units) < 0) {
                                    calcSum = parseFloat(calcVal.times(discount));
                                } else {
                                    calcSum = parseFloat(
                                        calcVal.minus(units).times(tariff).plus(units.times(discount))
                                    );


                                }
                                meter.discount = discount;
                            } else {
                                calcSum = parseFloat(calcVal.times(tariff));




                            }

                            meter.Amount = (calcSum >= 0 ? calcSum : 0).toFixed(2);
                            return meter.Amount;
                        },
                        validateNewMeter: function (name, isValid, value) {

                            var validate = (!value && value > 0) || isValid;
                            $scope.formcontroller.$setValidity(name, validate);

                        },
                        addMetersWatch: function (products) {
                              for (var i = 0; i < products.length; i++) {
                                if (products[i].meters && products[i].meters.length) {
                                    $scope.$watch('Utilities.products[' + i + '].meters', function (meters) {

                                        for (meter in meters) {
                                            if (meter.mode) {
                                                var validate = false;
                                                if (+meter.current != 0 && +meter.tariff != 0) {
                                                    validate = true;
                                                } else {
                                                    validate = false;
                                                }
                                                $scope.formcontroller.$setValidity('paymentForm', validate);
                                            }
                                        };
                                        
                                        if (
                                            products[i].amountInput ||
                                            products[i].amountInput === 0
                                        ) {

                                          products[i].amountInput =
                                              products[i].amount ? products[i].amount : 0;



                                            for (meter in meters) {
                                                products[i].amountInput =
                                                    (new BigNumber(products[i].amountInput))
                                                    .plus(meter.Amount || 0).toFixed(2);
                                            };

                                            Utilities.calcDebt(products[i]);
                                        }
                                    }, true);
                                }
                            };
                        },
                        checkUnit: function (serviceID, meter) {
                            $scope.formcontroller.$setValidity('paymentForm', false);

                            var isShow = false;
                            for (num in tariffConfig.energyCalc) {
                                if (num == serviceID) {
                                    isShow = true;
                                    return;
                                }
                            };
                            return isShow;
                        },
                        calcDebt: function (product) {
                            var calcMin = parseFloat((new BigNumber(product.amountInput)).plus(product.debt));
                            if (product.debt < 0 && product.amountMin) {
                                product.amountMin = calcMin > 0 ? calcMin.toFixed(2) : 1.00;
                            }
                        },
                        getDateFormat: function (dateStr) {
                            var type;
                            switch (true) {
                                case /^\d{1,2}\.\d{4}$/.test(dateStr):
                                    type = 'mm.yy';
                                    break;
                                case /^\d{4}\.\d{1,2}$/.test(dateStr):
                                    type = 'yy.mm';
                                    break;
                                case /^\d{4}\.\d{1,2}\.\d{1,2}$/.test(dateStr):
                                    type = 'yy.mm.dd';
                                    break;
                                default:
                                    type = 'dd.mm.yy';
                            }

                            return type;
                        },
                        abs: function (n) {
                            return Math.abs(n);
                        },
                        periodDifference: function (fields, product) {

                            var currentDate = new Date();
                            var currentYearMonth = currentDate.getFullYear() + "" + currentDate.getMonth();

                            if (product.billTypeId === 'be05964a-d77c-4d7c-b62d-4adbe186d64c') {

                                for (var i = 0; i < fields.length; i += 1) {
                                    if (fields[i].type === 'PERIOD') {
                                        var difference = parseFloat(currentYearMonth) - parseFloat(fields[i].value);

                                        return difference > 1 && product.amountInput === 0 ? true : false;
                                    };
                                };
                            };
                        },
                        only: function (value) {

                        }
                    };


                    $scope.chosenProduct = {};

                    var counter = 0;

                    $scope.$watch('form.utilitiesForm.data', function (products) {
                        if (!products) {
                            Utilities.products = [];
                            return;
                        }

                        if (!angular.equals(Utilities.products, products)) {
                            Utilities.products = products;
                        }

                        if (counter++ < 1) {
                            Utilities.addMetersWatch(products);
                        }

                        Utilities.selectedProducts = [];
                        $scope.form.service.service.amount = 0;
                        if (Utilities.products.length === 1) {
                            Utilities.selectedProducts = Utilities.products;
                            $scope.form.service.service.amount = $scope.form.service.payment.amount ? $scope.form.service.payment.amount : 0;
                        }

                        for (product in Utilities.products) {
                            if ($scope.chosenProduct === Utilities.products[product].serviceName) {
                                Utilities.selectedProducts.push(Utilities.products[product]);
                                product.check = true;
                            };
                        };

                        countAmount();

                    }, true);

                    $scope.$watch('form.utilitiesForm.selectedProduct', function (product) {
                        if (!product) {
                            return;
                        }

                        for (item in Utilities.products) {
                            if (Utilities.products[item].productId === product.productId) {
                                Utilities.products[item].check = true;
                            } else {
                                Utilities.products[item].check = false;
                            }
                          };
                        });

                    $scope.Utilities = Utilities;
                }
            ],
            link: function (scope, element, attr) {}
        };
    }
]);

module.exports = 'directives.utilities';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/utilities/utilities.directive.js
 ** module id = 240
 ** module chunks = 1
 **/